import React, { useEffect } from 'react'

import PageLayout from 'components/layouts/PageLayout'
import SectionLayout from 'components/layouts/SectionLayout'
import BigBanner from 'components/BigBanner'
import { GroupHealthBannerContent } from './content/GroupHealthBannerContent'
import Carriers from 'components/Carriers'

import SecondSection from './content/SecondSection'
import ThirdSection from './content/ThirdSection'
import StatesCollapse from 'components/StatesCollapse'
import CallToActionPHI from 'components/CallToActionPHI'
import FourthSection from './content/FourthSection'

import FifthSection from './content/FifthSection'
import SixthSection from './content/SixthSection'
import SeventhSection from './content/SeventhSection'

function GroupHealth() {

  useEffect(() => {
    // Change Tab Title
    document.title = "Group Health - Insurance Enterprise"
  }, [])
  
  return (
    <>

      <BigBanner content={<GroupHealthBannerContent />} />
      <PageLayout
        content={
          <>
            <SectionLayout content={<Carriers />} />
            <SectionLayout content={<SecondSection />} />
            <SectionLayout content={<ThirdSection />} />
            <SectionLayout content={<FourthSection />} background='bg-blurred-banner backdrop-brightness-200 bg-cover bg-center bg-no-repeat' />
            <SectionLayout content={<FifthSection />} />
            <SectionLayout content={<SixthSection />} />
            <SectionLayout content={<SeventhSection />} background='bg-blurred-banner backdrop-brightness-200 bg-cover bg-center bg-no-repeat'/>
            <SectionLayout content={<StatesCollapse />} background='bg-[#F5ECEC]'/>
            <SectionLayout content={<CallToActionPHI />}/>
          </>
        }
      />

    </>
  )
}

export default GroupHealth